<template>
    <div class="field__states">
        <base-states
            v-for="( state, index ) in states"
            class="field__states__value"
            :class="{ 'field__states__value--inactive pointer': model !== state }"
            :value="state"
            @click.native="model !== state ? selectState( state ) : null"
            :key="index"
        />
    </div>
</template>

<script>
// package
import { ref } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

export default {
    inheritAttrs: false,
    components: {
        BaseStates: () => import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' )
    },
    props: {
        states: Array,
        reset: Boolean,
        defaultValue: Number
    },
    setup ( props, { emit }) {
        const model = ref( props.defaultValue );

        // listener para quando for necessário
        // proceder a um reset a input.
        reset({
            props,
            object: model,
            key: 'value'
        });

        const selectState = state => {
            model.value = state;
            emit( 'input', state );
        };

        return { model, selectState };
    }
};
</script>